import { ScreenSize } from '@/styles'
import styled from 'styled-components/native'

export const Container = styled.View`
  flex: 1;
  max-width: ${({ screenSize }) =>
    screenSize >= ScreenSize.Medium ? '350px' : '100%'};
`
